import http from "../../http"

import {API_V1_URL} from "../../constants/other"


const COUPONS_URL = `${API_V1_URL}/coupons/`


export const getCoupons = (params) => http.get(COUPONS_URL, {params})
